/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import {
  CidadeInputV2,
  DefaultSelectV2,
  EstadoInputV2,
  InputV2,
} from '../../../components/v2';
import { ENDERECO_ENTREGA_TIPO_OPTIONS } from './requisicaoArea';

const campoVazio = (endereco, key) => !String(endereco?.[key] || '').trim();

const EnderecoEntregaFields = ({
  tipo,
  endereco,
  error,
  onTipo,
  onEndereco,
}) => {
  const outro = tipo === 'OUTRO';
  const valor = endereco || {};

  return (
    <>
      <Grid size={{ xs: 12, sm: 4 }}>
        <DefaultSelectV2
          label="Entrega em"
          options={ENDERECO_ENTREGA_TIPO_OPTIONS}
          value={tipo || 'RESIDENCIAL'}
          isRequired
          showEmpty={false}
          onSelect={(event) => onTipo(event.target.value || 'RESIDENCIAL')}
        />
      </Grid>
      {outro && (
        <>
          <Grid size={{ xs: 12, sm: 8 }}>
            <InputV2
              label="Rua"
              name="rua"
              isRequired
              error={error && campoVazio(valor, 'rua')}
              value={valor.rua || ''}
              onChange={(event) => onEndereco({ rua: event.target.value })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="Número"
              name="numero"
              isRequired
              error={error && campoVazio(valor, 'numero')}
              value={valor.numero || ''}
              onChange={(event) => onEndereco({ numero: event.target.value })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="Complemento"
              name="complemento"
              value={valor.complemento || ''}
              onChange={(event) => onEndereco({ complemento: event.target.value })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="Bairro"
              name="bairro"
              value={valor.bairro || ''}
              onChange={(event) => onEndereco({ bairro: event.target.value })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="CEP"
              name="cep"
              isRequired
              error={error && campoVazio(valor, 'cep')}
              value={valor.cep || ''}
              onChange={(event) => onEndereco({ cep: event.target.value })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <EstadoInputV2
              estado={valor.estado || ''}
              isRequired
              error={error && campoVazio(valor, 'estado')}
              onSelect={(estado) => onEndereco({ estado, cidade: '' })}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <CidadeInputV2
              estado={valor.estado || ''}
              cidade={valor.cidade || ''}
              isRequired
              error={error && campoVazio(valor, 'cidade')}
              onSelect={(cidade) => onEndereco({ cidade })}
            />
          </Grid>
        </>
      )}
    </>
  );
};

EnderecoEntregaFields.propTypes = {
  tipo: PropTypes.string,
  endereco: PropTypes.object,
  error: PropTypes.bool,
  onTipo: PropTypes.func.isRequired,
  onEndereco: PropTypes.func.isRequired,
};

EnderecoEntregaFields.defaultProps = {
  tipo: 'RESIDENCIAL',
  endereco: {},
  error: false,
};

export default EnderecoEntregaFields;
